import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useEffect, useCallback } from 'react';
import FocusLock from 'react-focus-lock';
import { RemoveScroll } from 'react-remove-scroll';
import { KEYBOARD } from '../constants/index.js';
import Portal from '../portal/index.js';
import { Container } from './styled.js';
import { jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Modal(props) {
  var children = props.children,
    initialFocusRef = props.initialFocusRef,
    _props$closeOnOutside = props.closeOnOutsideClick,
    closeOnOutsideClick = _props$closeOnOutside === void 0 ? true : _props$closeOnOutside,
    _props$closeOnEscape = props.closeOnEscape,
    closeOnEscape = _props$closeOnEscape === void 0 ? true : _props$closeOnEscape,
    onClose = props.onClose,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    _props$overlay = props.overlay,
    overlay = _props$overlay === void 0 ? false : _props$overlay,
    restProps = __rest(props, ["children", "initialFocusRef", "closeOnOutsideClick", "closeOnEscape", "onClose", "autoFocus", "overlay"]);
  var overlayRef = useRef(null);
  useEffect(function () {
    var handleDocumentClick = function handleDocumentClick(event) {
      var clickedOutside = event.target === overlayRef.current;
      if (closeOnOutsideClick && clickedOutside && onClose) {
        onClose(event);
      }
    };
    var handleDocumentKeyUp = function handleDocumentKeyUp(event) {
      var pressedEscapeKey = event.key === KEYBOARD.ESC;
      if (closeOnEscape && pressedEscapeKey && onClose) {
        onClose(event);
      }
    };
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keyup', handleDocumentKeyUp);
    return function () {
      document.removeEventListener('click', handleDocumentClick);
      document.removeEventListener('keyup', handleDocumentKeyUp);
    };
  });
  var handleActivation = useCallback(function () {
    if (initialFocusRef && initialFocusRef.current) {
      initialFocusRef.current.focus();
    }
  }, [initialFocusRef]);
  return /*#__PURE__*/jsx(Portal, {
    children: /*#__PURE__*/jsx(FocusLock, {
      autoFocus: autoFocus,
      returnFocus: true,
      onActivation: handleActivation,
      children: /*#__PURE__*/jsx(RemoveScroll, {
        children: /*#__PURE__*/jsx(Container, _extends({
          $overlay: overlay,
          "aria-modal": "true"
        }, restProps, {
          ref: overlayRef,
          children: children
        }))
      })
    })
  });
}

export { Modal as default };
